import React, { useEffect, useState } from 'react';
import '../../../assets/styles/KYC.css';
import {
    DataGrid, GridToolbar, GridToolbarContainer,
    GridToolbarExport,
} from '@material-ui/data-grid';
import { useDistributorContext } from '../../../services/contexts/DistributorContext';
import { configs, formatCurrency } from '../../../assets/Config';
import { Link } from 'react-router-dom';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { useHistory } from 'react-router-dom';


export default function CustomerProReportPage() {

    const { error, getProUserReport, proUserReport, setKycRequesterUserDetail, setKycRequesterUserComplete, setpanDoc,
        setaddressDoc,
        setbankDoc,
        setdematDoc } = useKYCContext()

    const { allowedFunc, setCurrModule } = useLogin()

    const history = useHistory()

    useEffect(() => {
        if (allowedFunc.includes(configs.functionList['user_pro:user_pro'])) {
            setCurrModule(configs.modules.custProReport, true)
        } else {
            return history.goBack()
        }
    }, [])

    // declare table rows
    const [columns, setColumns] = useState([
        { field: "id", headerName: "ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
        { field: "name", headerName: "Name", minWidth: 100, flex: 0.4, cellClassName: "break-text" },
        {
            field: "email", headerName: "E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                    return <Link to={`/customerProfile/${params.row.id}`} onClick={() => {
                        setKycRequesterUserDetail(params.row)
                    }}>{params.row.email}</Link>
                } else {
                    return params.row.email
                }
            }, valueGetter: (value) => value.row.email
        },
        {
            field: "mobile", headerName: "Mobile No.", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
                return <a href={"https://wa.me/" + params.row.mobile} target="_blank">{params.row.mobile ? `+${params.row.mobile}` : params.row.mobile}</a>
            }, valueGetter: (value) => value.row.mobile ? `+${value.row.mobile}` : value.row.mobile
        },
        { field: "account_type", headerName: "Account Type", minWidth: 170, flex: 0.5, cellClassName: "break-text" },
        {
            field: "parent_id", headerName: "Parent ID", minWidth: 100, flex: 0.4, hide: true, cellClassName: "break-text", renderCell: (params) => {
                return params.row.parent.parent_id
            }, valueGetter: (value) => value.row.parent.parent_id
        },
        {
            field: "parent_name", headerName: "Parent Name", minWidth: 100, flex: 0.4, cellClassName: "break-text", renderCell: (params) => {
                return params.row.parent.parent_name
            }, valueGetter: (value) => value.row.parent.parent_name
        },
        {
            field: "parent_email", headerName: "Parent E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                    return <Link to={`/customerProfile/${params.row.parent.parent_id}`} onClick={() => {
                        setKycRequesterUserDetail({ id: params.row.parent.parent_id })
                    }}>{params.row.parent.parent_email}</Link>
                } else {
                    return params.row.parent.parent_email
                }
            }, valueGetter: (value) => value.row.parent.parent_email
        },
        {
            field: "parent_mobile", headerName: "Parent Mobile No.", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
                return <a href={"https://wa.me/" + params.row.parent.parent_mobile} target="_blank">{params.row.parent.parent_mobile ? `+${params.row.parent.parent_mobile}` : params.row.parent.parent_mobile}</a>
            }, valueGetter: (value) => value.row.parent.parent_mobile ? `+${value.row.parent.parent_mobile}` : value.row.parent.parent_mobile
        },
        {
            field: "parent_account_type", headerName: "Parent Account Type", minWidth: 170, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.parent.parent_account_type
            }, valueGetter: (value) => value.row.parent.parent_account_type
        },

    ])

    // get list of kyc requesters
    useEffect(() => {
        (async () => {
            try {
                await getProUserReport();
            } catch (error) {

            }
        })();
    }, [])

    // react data table export option
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport csvOptions={{ allColumns: true }}/>
            </GridToolbarContainer>
        );
    }

    // admin kyc requesters basic details ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='custStatContainer' className="smbo-container">
                    <div style={{ width: "100%" }}>
                        <div className="row mx-md-4 mx-2 my-2 p-0">
                            <p className="text-custom-grey h3 mt-2 ml-3">Pro User Report</p>
                        </div>
                        <div className="kyc-table">
                            {proUserReport ? <DataGrid
                                rows={proUserReport}
                                columns={columns}
                                resizable={true}
                                autoPageSize
                                rowHeight={40}
                                headerHeight={30}
                                pagination
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                            />
                                : <div className="loader"></div>}
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}